import { render, staticRenderFns } from "./SchoolNotificationDetail.vue?vue&type=template&id=1105080d"
import script from "../../services/notification/school-notification-detail.js?vue&type=script&lang=js&external"
export * from "../../services/notification/school-notification-detail.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/notification/school-notification-detail.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports